import { render, staticRenderFns } from "./SliceEmbed.vue?vue&type=template&id=19134064&lang=pug&"
import script from "./SliceEmbed.vue?vue&type=script&lang=js&"
export * from "./SliceEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports